import React, { Component } from 'react';
import AppContentComponent from '../../../templates/content'
import { app } from "../../../../config/constants"
import { Link } from 'react-router-dom';
import { api } from "../../../../api";
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

import {
	Table,
	TableBody,
	TableFooter,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn,
} from 'material-ui/Table';

class AppPromotionsListComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			promotions: [],
			loaded: false,
			perPage: 20,
			totalPromotions: 0,
			currentPage: 0,
			maxPages: 0,
			dialog: {
				open: false,
				promotionToDelete: {}
			}
		};

		this.setPage = this.setPage.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.openDeleteConfirmModal = this.openDeleteConfirmModal.bind(this);
		this.deletePromotion = this.deletePromotion.bind(this);
		this.getPromotionsList = this.getPromotionsList.bind(this);
	}

	async isActive( childSnap ) {
		const currentTime = Date.now();
		return new Promise( ( resolve, reject ) => {
			let i = 0;
			if ( 'branded' === childSnap.val().position || 'topic_partner' === childSnap.val().position ) {
				if (
					childSnap.val().startDateTimeStamp <= currentTime &&
					(
						0 === childSnap.val().endDateTimeStamp ||
						childSnap.val().endDateTimeStamp >= currentTime
					)
				) {
					resolve({
						active: true,
						status: 'active',
					});
				} else {
					resolve({
						active: false,
						status: 'ended',
					});
				}
			}

			app.database().ref( '/cams/promotions/periods').orderByChild('promotionID').equalTo(childSnap.key).once( 'value', ( periodSnap ) => {
				if ( 0 === periodSnap.numChildren() ) {
					resolve({
						active: false,
						status: 'ended',
					});
				}

				new Promise( ( resolve, reject ) => {
					periodSnap.forEach( ( period ) => {
						if ( period.val().startDateTimeStamp <= currentTime && ( period.val().endDateTimeStamp >= currentTime || undefined === period.val().endDateTimeStamp || '' === period.val().endDateTimeStamp || 0 === period.val().endDateTimeStamp ) ) {

							if ((0 !== period.val().endDateTimeStamp && undefined !== period.val().endDateTimeStamp) && (((period.val().endDateTimeStamp - currentTime) / 1000) < 253200)) {
								resolve({
									active: true,
									status: 'ending',
								});
							}

							// Get the period variants
							new Promise( ( resolve, reject ) => {
								app.database().ref( 'cams/promotions/variants').orderByChild('periodId').equalTo( period.key ).once( 'value', variantsSnap => {
									if ( variantsSnap.numChildren() > 1 ) {
										resolve({
											active: true,
											status: 'testing',
										});
									} else {
										resolve({
											active: true,
											status: 'active',
										});
									}
								});
							}).then( status => {
								resolve( status );
							});
						} else {
							if ( ++i === periodSnap.numChildren() ) {
								resolve({
									active: false,
									status: 'ended',
								});
							}
						}

					});
				}).then( status => {
					resolve( status );
				})
			});
		} );
	}

	loadPromotions() {
		let promotionsRef = app.database().ref('cams/promotions/promotions');

		this.setState({
			...this.state,
			promotions: [],
		});

		const startNum = this.state.currentPage * this.state.perPage;
		let startPosition = this.state.promotionsList[ startNum ];

		if ( undefined === startPosition ) {
			startPosition = this.state.promotionsList.pop();
		}

		let i = 0;
		promotionsRef.orderByKey().endAt(startPosition).limitToLast(this.state.perPage).once('value', (snapshot) => {
			snapshot.forEach( (childSnap) => {
				let obj = {
					key: childSnap.key,
					promotion: childSnap.val(),
					sort: i++
				};

				new Promise( async ( resolve, reject ) => {
					const isActive = await this.isActive( childSnap );
					resolve( isActive );
				}).then( ( active ) => {
					obj.active = active;

					this.setState({
						...this.state,
						promotions: [
							...this.state.promotions,
							obj
						],
						loaded: true,
					});
				});
			});
		});
	}

	getPromotionsList() {
		let promotionsRef = app.database().ref('cams/promotions/promotions');

		return new Promise( ( resolve, reject ) => {
			promotionsRef.once('value', ( snapShot ) => {
				let keyList = [];
				let i = 0;


				snapShot.forEach( ( promotion ) => {
					keyList.push( promotion.key );

					if ( ++i === snapShot.numChildren() ) {
						resolve({
							keyList: keyList,
							children: snapShot.numChildren(),
						});
					}
				});
			});
		});
	}

	componentDidMount() {
		this.init();
	}

	init() {
		this.getPromotionsList().then( ( data ) => {
			this.setState({
				promotionsList: data.keyList.reverse(),
				totalPromotions: data.children,
				maxPages: Math.ceil( data.children / this.state.perPage )
			});

			this.loadPromotions();
		});
	}

	setPage(page) {
		this.state = {
			...this.state,
			currentPage: page
		};

		this.loadPromotions();
	}

	createPagination() {
		let ul = [];

		for ( let i = 0; i < this.state.maxPages; i++ ) {
			ul.push(<li className={this.state.currentPage === i ? 'current' : ''} key={i}><a onClick={() => this.setPage(i)}>{i + 1}</a></li>)
		}

		return ul;
	}

	openDeleteConfirmModal(promotion, event) {
		event.preventDefault();

		this.setState({
			...this.state,
			dialog: {
				...this.state.dialog,
				open: true,
				promotionToDelete: promotion
			}
		});
	}

	deletePromotion() {
		api.promotions.deletePromotion( this.state.dialog.promotionToDelete ).then( () => {
			this.setState({
				...this.state,
				dialog: {
					...this.state.dialog,
					open: false,
					promotionToDelete: {}
				}
			})

			this.init();
		});
	}

	closeDialog() {
		this.setState({
			...this.state,
			dialog: {
				...this.state.dialog,
				open: false
			}
		})
	}

	render() {
		const styles = {
			deleteRow: {
				textAlign: 'right'
			}
		};

		const PromotionsList = this.state.promotions.sort( ( a, b ) => {

			if(a.sort < b.sort) return -1;
			if(a.sort > b.sort ) return 1;
			return 0;

		} ).map((promotion, key ) =>
			<TableRow key={key}>
				<TableRowColumn><Link to={{ pathname: '/app/promotions/promotion/' + promotion.key}}>{promotion.promotion.name}</Link></TableRowColumn>
				<TableRowColumn className={promotion.active.active ? 'active' : 'inactive'}>
					<div className={`promotion__status promotion__status--${promotion.active.status}`}></div>
				</TableRowColumn>
				<TableRowColumn style={styles.deleteRow} className={'promotion__delete'}>
					<FlatButton label="Verwijderen" secondary={true} onClick={this.openDeleteConfirmModal.bind(null, promotion)} />
				</TableRowColumn>
			</TableRow>
		).reverse();

		const deleteActions = [
			<FlatButton
				label="Annuleer"
				onClick={this.closeDialog}
			/>,
			<FlatButton
				label="Doorgaan"
				secondary={true}
				keyboardFocused={true}
				onClick={this.deletePromotion}
			/>,
		];

		return (
			<AppContentComponent>
				<h1>Promoties</h1>
				<Table selectable={false}>
					<TableHeader displaySelectAll={false}>
						<TableRow>
							<TableHeaderColumn>Titel</TableHeaderColumn>
							<TableHeaderColumn>Status</TableHeaderColumn>
							<TableHeaderColumn>Verwijderen</TableHeaderColumn>
						</TableRow>
					</TableHeader>
					<TableBody displayRowCheckbox={false}>
						{PromotionsList}
					</TableBody>
					<TableFooter>
						<TableRow>
							<TableRowColumn>Name</TableRowColumn>
							<TableRowColumn>Status</TableRowColumn>
						</TableRow>
					</TableFooter>
				</Table>

				<ul className={'cams-pagination text-center'}>{this.createPagination()}</ul>

				<div>
					<Dialog
						title="Promotie verwijderen"
						actions={deleteActions}
						modal={false}
						open={this.state.dialog.open}
						onRequestClose={this.handleClose}
					>
						Weet je zeker dat je deze promotie wilt verwijderen? Alle statistieken voor deze promotie zullen ook worden verwijderd.
					</Dialog>
				</div>
			</AppContentComponent>
		)
	}
}

export default AppPromotionsListComponent;


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/index.js